import React, { useRef, useCallback, useState } from 'react';
import { Icon, Tooltip } from 'antd';
import { ScrollContainer } from './styles';
import {
  cancellablePromise,
  useCancellablePromise,
} from '../../containers/EmailDesignPage/EmailBuilder/cancellablePromise';

const MIN_GAP = 40;

const ScrollContainerV2 = (props) => {
  const scrollRef = useRef(null);
  const { fetchMoreData, customClassName, onScroll = () => {} } = props;
  const [isScrolling, toggleScroll] = useState(false);
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const { addCancellablePromise, removePendingPromise, clearPendingPromises } = useCancellablePromise();
  const { addCancellablePromise: addFetchingPromise, removePendingPromise: removeFetchingPromise, clearPendingPromises: clearFetchingPromises } = useCancellablePromise();

  const handleScroll = useCallback((e) => {
    if (!isScrolling) {
      toggleScroll(true);
    } else {
      // should this be called???
      clearPendingPromises();
      const isScrollEnd = cancellablePromise(new Promise(resolve => setTimeout(() => {
        resolve(e);
      }, 200)));
      addCancellablePromise(isScrollEnd);

      isScrollEnd.promise.then(() => {
        removePendingPromise(isScrollEnd);
        toggleScroll(false);
      }).catch(() => {
        removePendingPromise(isScrollEnd);
      });
    }

    clearFetchingPromises();
    const isFetchingCalled = cancellablePromise(new Promise(resolve => setTimeout(() => {
      resolve(e);
    }, 200)));
    addFetchingPromise(isFetchingCalled);
    if (onScroll) {
      onScroll(scrollRef.current.scrollTop > (scrollRef.current.clientHeight * 0.10));
    }

    isFetchingCalled.promise.then(() => {
      let reference = scrollRef.current;
      if (
        reference.scrollTop !== 0 &&
        Math.abs(reference.scrollHeight - reference.scrollTop - reference.clientHeight) <= MIN_GAP
      ) {
        fetchMoreData();
      }
      if (reference.scrollTop > (reference.clientHeight * 0.10)) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    }).catch(() => {
      removeFetchingPromise(isFetchingCalled);
    })
  }, [isScrolling, fetchMoreData]);

  const smoothScroll = useCallback(() => {
    scrollRef.current.scrollTop = 0;
  }, []);

  return (
    <ScrollContainer ref={scrollRef} className={`${isScrolling ? 'on-scrollbar' : ''} ${customClassName}`} onScroll={handleScroll}>
      {props.children}
      {showScrollToTop && (
        <Tooltip placement="left" title={'Scroll to top'}>
          <Icon className="arrow-up" type="arrow-up" onClick={smoothScroll} />
        </Tooltip>
      )}
    </ScrollContainer>
  );
}

export default ScrollContainerV2;